import React from "react";
import { Route, Switch } from "react-router";
import OrganizationCarriersPage from "pages/_common/organization/OrganizationCarriersPage";
import OrganizationCarriersCreatePage from "pages/_common/organization/OrganizationCarriersCreatePage";

/**
 * Organization Carriers Router
 */
const OrganizationCarriersRouter = () => {
  return (
    <Switch>
      <Route exact path="/organizations/:organization_id/carriers" component={OrganizationCarriersPage} />
      <Route
        path="/organizations/:organization_id/carriers/:carrier_id/edit"
        component={OrganizationCarriersCreatePage}
      />
      <Route path="/organizations/:organization_id/carriers/create" component={OrganizationCarriersCreatePage} />
    </Switch>
  );
};

export default OrganizationCarriersRouter;
